import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { HttpParams } from  '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
	base_url = DDP_ENV.baseUrl;
	deviceTypeBaseUrl = DDP_ENV.deviceTypeBaseUrl;
	constructor(private _router: Router, private _http: Http, private cookieService: CookieService) {}

	/* Get all devices */
	getAll(): Observable<any> {
		return this._http.get(this.base_url + '/device' , this.buildHeaders())
					   .map((res: Response) => res.json());
	}

	/* Get all devices for a user */
	getUserDevices(userId: string): Observable<any> {
		return this._http.get(this.base_url + '/user/' + userId + '/device' , this.buildHeaders())
					   .map((res: Response) => res.json());
	}

	/* Get all devices for a campaign */
	getCampaignDevices(campaignId: string): Observable<any> {
		return this._http.get(this.deviceTypeBaseUrl + '/campaign/' + campaignId + '/device' , this.buildHeaders())
			.map((res: Response) => res.json());
	}

	/* Get a device */
	getOne(id: string): Observable<any> {
		return this._http.get(this.deviceTypeBaseUrl + '/device/' + id , this.buildHeaders())
					   .map((res: Response) => res.json());
	}

	/* Get a device activation */
	getOneActivation(id: string): Observable<any> {
		return this._http.get(this.base_url + '/device/activation/' + id , this.buildHeaders())
					   .map((res: Response) => res.json());
	}

	/* Update a device */
	update(device: any): Observable<any> {
		return this._http.put(this.base_url + '/device/' + device.id , device , this.buildHeaders())
			.map((res: Response) => {
				return res.json();
			});
	}

	/* createOrUpdate a device */
	createOrUpdate(device: any): Observable<any> {
		return this._http.post(this.base_url + '/device' , device , this.buildHeaders())
			.map((res: Response) => {
				return res.json();
			});
	}

	/* delete a device */
	delete(id: string): Observable<any> {
		return this._http.delete(this.base_url + '/device/' + id, this.buildHeaders())
			.map((res: Response) => {
				return res.json();
			});
	}

	/* createOrUpdateForUser a device for a user */
	createOrUpdateForUser(userId, device): Observable<any> {
		return this._http.put(this.base_url + '/user/' + userId + '/device', device , this.buildHeaders())
			.map((res: Response) => {
				return res.json();
			});
	}

	/* delete a device from user*/
	deleteFromUser(userId: string, deviceId: any): Observable<any> {
		return this._http.delete(this.base_url + '/user/' + userId + '/device/' + deviceId, this.buildHeaders())
			.map((res: Response) => {
				return res.json();
			});
	}

	/* Create Device Activation
		params: { flag: false } needs to be added. Do not know how.
	*/
	createDeviceActivation(deviceActivation: any): Observable<any> {
		return this._http.post(this.base_url + '/client/' + deviceActivation.clientId + '/device/activation' , deviceActivation , this.buildHeaders())
			.map((res: Response) => {
				return res.json();
			});
	}

	/* Update Device Activation */
	updateDeviceActivation(deviceActivation): Observable<any> {
		return this._http.put(this.base_url + '/client/' + deviceActivation.clientId + '/device/activation/' + deviceActivation.id, deviceActivation, this.buildHeaders())
			.map((res: Response) => {
				return res.json();
			});
	}

	/* Get Device Activations Page */
	getDeviceActivationsPaged(pattern, status, page, size): Observable<any> {
		return this._http.get(this.base_url + '/device/activation', this.buildHeadersForDeviceActivation(page, size))
					   .map((res: Response) => res.json());
	}

	/* Construct a common header */
	private buildHeaders(): any {
		const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
		return new RequestOptions({ headers: headers });
	}

	/* Build request header */
	private buildHeadersForDeviceActivation(page, size): any {
		page = page || 0;
		size = size || 9999999;
		const params = new HttpParams()
			.set('page', page)
			.set('size', size);
		const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
		return new RequestOptions({ headers: headers, params: params });
	}

}
